<template>
    <el-upload
        :action="action"
        :name="name"
        :headers="headers"
        v-bind="$attrs"
        v-on="$listeners"
        :on-error="onError"
    >
        <slot />
    </el-upload>
</template>

<script>
/**
 * ComponentName: 上传组件
 * Created Date:2022/5/9
 * Author: zenan·yu
 * Modify: 
 * 组件说明：
 * eg:
 *     <cl-upload></cl-upload>
 */
    export default {
        name: 'cl-upload',
        props: {
            url: {
                type: String,
                default: '/common/upload'
            },
            name: {
                type: String,
                default: 'file'
            },
        },
        data() {
            let token
            try {
                token = JSON.parse(window.sessionStorage.getItem('store')).token
            } catch{()=>{}}
            return {
                description: '文件上传',
                headers: {
                    Authorization: 'Bearer ' + token
                },
            }
        },

        computed: {
            action() {
                let baseUrl = process.env.VUE_APP_BASEURL
                return baseUrl + this.url
            }
        },

        methods: {
            onError(e) {
                this.$message.error(this.$t('error.上传失败'))
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>
